import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  VStack,
  useDisclosure,
  useToast,
  Text,
} from "@chakra-ui/react";
import React, { useContext, useState } from "react";
import { FaChartLine, FaUserCircle } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { AiOutlineHistory } from "react-icons/ai";
import { BsFillCreditCardFill, BsLightningChargeFill, BsCurrencyBitcoin } from "react-icons/bs";
import { MdBlock, MdOutlineLocalOffer } from "react-icons/md";
import { SlGraph } from "react-icons/sl";
import { AppContext } from "../../../context/AppContext";
import { useNavigate } from "react-router-dom";
import { RiMessage2Fill } from "react-icons/ri";
import { FaServer } from "react-icons/fa6";

const ButtonsList = [
  {
    title: "Dashboard",
    icon: <FaChartLine style={{ fontSize: "1.3rem" }} />,
    link: "/admin/dashboard",
  },
  {
    title: "Users",
    icon: <FaUserCircle style={{ fontSize: "1.3rem" }} />,
    link: "/admin/users",
  },
  {
    title: "Recharge",
    icon: <BsLightningChargeFill style={{ fontSize: "1.3rem" }} />,
    link: "/admin/recharge",
  },
  {
    title: "Daily Stats",
    icon: <SlGraph style={{ fontSize: "1.3rem" }} />,
    link: "/admin/daily",
  },
  {
    title: "Currency",
    icon: <BsCurrencyBitcoin style={{ fontSize: "1.3rem" }} />,
    link: "/admin/currency",
  },
  {
    title: "Services",
    icon: <BsFillCreditCardFill style={{ fontSize: "1.3rem" }} />,
    link: "/admin/services",
  },
  {
    title: "Server",
    icon: <FaServer style={{ fontSize: "1.3rem" }} />,
    link: "/admin/server",
  },
  {
    title: "Transactions",
    icon: <AiOutlineHistory style={{ fontSize: "1.3rem" }} />,
    link: "/admin/transaction",
  },
  {
    title: "Otp history",
    icon: <RiMessage2Fill style={{ fontSize: "1.3rem" }} />,
    link: "/admin/otp-history",
  },
  {
    title: "Jiomart history",
    icon: <RiMessage2Fill style={{ fontSize: "1.3rem" }} />,
    link: "/admin/jiomart-history",
  },
  {
    title: "Coupon",
    icon: <MdOutlineLocalOffer style={{ fontSize: "1.3rem" }} />,
    link: "/admin/coupon",
  },
  {
    title: "Blocked Users",
    icon: <MdBlock style={{ fontSize: "1.4rem" }} />,
    link: "/admin/blockedusers",
  },
  { title: "Logout", icon: <FiLogOut style={{ fontSize: "1.3rem" }} /> },
];

const AdminLeftSideBar = ({ onClose: closeMobileDrawer }) => {
  const [active, setActive] = useState("");
  const { isDark, setIsAdmin } = useContext(AppContext);
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const navigate = useNavigate();

  const handleLogout = () => {
    onClose();
    localStorage.removeItem("Token");
    setIsAdmin(false);
    toast({
      status: "success",
      title: "Successfully logout",
      isClosable: true,
      duration: 2000,
    });
  };

  return (
    <VStack
      w={["100%", "100%", "220px"]}
      minH="100vh"
      pt="1rem"
      pb="1rem"
      bg={isDark ? "gray.800" : "white"}
      borderRight={["none", "none", "1px solid #f0f0f0"]}
      align="start"
      gap="0.3rem"
    >
      {ButtonsList.map((el) => (
        <Button
          key={el.title}
          outline={"none !important"}
          onClick={() => {
            setActive(el.title);
            if ("Logout" === el.title) {
              onOpen();
            } else {
              navigate(el.link);
              if (closeMobileDrawer) closeMobileDrawer();
            }
          }}
          _hover={{
            background: "#fafafa !important",
            color: "rgb(220, 20, 60) !important",
          }}
          style={
            active === el.title
              ? {
                background: "white",
                color: "rgb(220, 20, 60)",
              }
              : {
                background: "transparent",
                color: isDark ? "white" : "black",
              }
          }
          gap={"0.6rem"}
          fontWeight={400}
          border={"none !important"}
          fontSize={"1rem"}
          p={"1.2rem 0.8rem"}
          w={"100%"}
          justifyContent={"start"}
          leftIcon={el.icon}
          colorScheme="white"
          color={"black"}
        >
          {el.title}
        </Button>
      ))}

      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent mx="1rem">
          <ModalCloseButton />
          <ModalBody
            display={"flex"}
            justifyContent={"center"}
            flexDirection={"column"}
            minH={"25vh"}
            gap={"1rem"}
            alignItems={"center"}
            pb={6}
            pt={8}
          >
            <Text fontWeight={600} fontSize="1.1rem" textAlign="center">
              Are you sure you want to logout?
            </Text>
            <Button
              onClick={handleLogout}
              _hover={{
                bgColor: "white",
                color: "rgb(220, 20, 60)",
              }}
              color={"white"}
              bgColor={"rgb(220, 20, 60)"}
              border={"2.4px solid rgb(220, 20, 60) !important"}
              w="full"
            >
              Logout
            </Button>
            <Button
              onClick={onClose}
              color={"rgb(220, 20, 60)"}
              bg={"white"}
              border={"2.4px solid rgb(220, 20, 60) !important"}
              _hover={{
                bgColor: "rgb(220, 20, 60)",
                color: "white",
              }}
              w="full"
            >
              Cancel
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </VStack>
  );
};

export default AdminLeftSideBar;
